import React, { useState } from 'react';
import { ChevronDown, Scale } from 'lucide-react';
import { TermsOfServiceModal } from '../legal/TermsOfServiceModal';
import { VEXATIOUS_CLAUSES, VEXATIOUS_REFS } from '../../lib/config/vexatiousClauses';

// Blocco mostrato nello step OTP di verifica email: l'inserimento del codice
// vale come firma elettronica semplice per l'approvazione SPECIFICA delle
// clausole vessatorie ex artt. 1341-1342 c.c. (Cass. ord. n. 20945/2026: la
// sola checkbox non basta). Le clausole devono essere leggibili QUI, prima di
// digitare il codice (il codice a 6 cifre si invia da solo): per questo il
// blocco resta SOPRA il campo, compatto, con i numeri delle clausole sempre
// visibili e i titoli apribili in un elenco a scorrimento.
export function VexatiousApprovalNotice() {
  const [showTerms, setShowTerms] = useState(false);
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="flex items-start gap-2 text-xs text-[#787774] leading-relaxed">
      <Scale className="w-3.5 h-3.5 mt-0.5 shrink-0 text-[#9B9A97]" aria-hidden="true" />
      <div className="min-w-0 flex-1">
        <p>
          Inserendo il codice approvi specificamente, ai sensi degli artt. 1341-1342 c.c., le clausole{' '}
          <span className="text-[#37352F]">{VEXATIOUS_REFS}</span> dei{' '}
          <button
            type="button"
            onClick={() => setShowTerms(true)}
            className="text-[#2383E2] hover:underline"
          >
            Termini e Condizioni
          </button>
          .
        </p>
        <button
          type="button"
          onClick={() => setExpanded(!expanded)}
          aria-expanded={expanded}
          aria-controls="vexatious-clauses-list"
          className="mt-1 inline-flex items-center gap-0.5 text-[#2383E2] hover:underline"
        >
          {expanded ? 'Nascondi i titoli delle clausole' : 'Vedi i titoli delle clausole'}
          <ChevronDown className={`w-3 h-3 transition-transform ${expanded ? 'rotate-180' : ''}`} aria-hidden="true" />
        </button>
        {expanded && (
          <ul
            id="vexatious-clauses-list"
            className="mt-1.5 max-h-36 overflow-y-auto rounded-md border border-[rgba(55,53,47,0.09)] bg-[rgba(55,53,47,0.02)] px-2.5 py-1.5 space-y-0.5 text-[11px]"
          >
            {VEXATIOUS_CLAUSES.map((c) => (
              <li key={c.ref} className="flex gap-1.5">
                <span className="w-7 shrink-0 font-medium text-[#37352F] tabular-nums">{c.ref}</span>
                <span>{c.title}</span>
              </li>
            ))}
          </ul>
        )}
      </div>

      <TermsOfServiceModal isOpen={showTerms} onClose={() => setShowTerms(false)} />
    </div>
  );
}
